export default __webpack_public_path__ + "static/media/p81.bbfe3285.jpg";